import { FileData } from './settings.types'

export enum UserRole {
  ADMIN = 'ADMIN',
  VIEWER = 'VIEWER',
  RESELLER = 'RESELLER',
  WHOLESALER = 'WHOLESALER',
}

export interface User {
  _id: string
  firstname: string
  lastname: string
  email: string
  phone: string
  role: UserRole
  wholesaler?:
    | string
    | Pick<
        User,
        | '_id'
        | 'firstname'
        | 'lastname'
        | 'email'
        | 'companyName'
        | 'fluxId'
        | 'primaryColor'
        | 'secondaryColor'
        | 'logo'
      >
    | null
  /** Commercial / brand name (grossiste & revendeur direct). */
  companyName?: string
  infos?: string
  address?: string
  city?: string
  postalCode?: string
  /** SIRET (14 digits) — required to create the Flux billing fiche. */
  siret?: string
  /** Bank account (RIB) — owner is required when an IBAN is provided. */
  accountOwner?: string
  iban?: string
  bic?: string
  fluxId?: number
  primaryColor?: string
  secondaryColor?: string
  logo?: FileData
  attachedResellersCount?: number
  lastLogin?: string
  createdBy?: string
  updatedBy?: string
  isArchived: boolean
  createdAt: string
  updatedAt: string
}

export interface CreateUserDto {
  firstname: string
  lastname: string
  email: string
  phone: string
  role: UserRole
  wholesaler?: string
  companyName?: string
  infos?: string
  address?: string
  city?: string
  postalCode?: string
  siret?: string
  accountOwner?: string
  iban?: string
  bic?: string
  primaryColor?: string
  secondaryColor?: string
  logo?: FileData
  /** Required for users; omitted for revendeur/grossiste (auto-generated server-side). */
  password?: string
}

export interface UpdateUserDto extends Partial<CreateUserDto> {}

